import { ReactNode } from 'react';
import { Box, styled } from '@mui/material';
import { Svg404 } from '@tymely/utils';
import { useDocumentTitle } from '@tymely/services';

const Root = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    height: '100%',
});

interface NotFoundPageProps {
    before?: ReactNode;
    after?: ReactNode;
}

const NotFoundPage = ({ before, after }: NotFoundPageProps) => {
    useDocumentTitle('Not Found');

    return (
        <Root>
            {before}
            <Svg404 />
            {after}
        </Root>
    );
};

export default NotFoundPage;
